// extracted by mini-css-extract-plugin
module.exports = {"message":"DeliveryHighlightMessage_message__91OJu","deliveryMessage":"DeliveryHighlightMessage_deliveryMessage__gEfa2"};